import type { ChoiceOption } from '@/shared/lib/choice-option';

// Sex offers Female and Male only — a client already holding 'other' keeps it until the
// therapist picks one.
export const SEX_OPTIONS: ChoiceOption[] = [
    { value: 'female', label: 'Female' },
    { value: 'male', label: 'Male' },
];
